'use strict';
import { isiOs, isIE, isChrome, isFirefox, isSafari } from './plugins/browser-checks';

window.viewport = function() {
    let e = window,
        a = 'inner';

    if (!('innerWidth' in window )) {
        a = 'client';
        e = document.documentElement || document.body;
    }

    return { width : e[ a+'Width' ] , height : e[ a+'Height' ] };
}

window.prefersReducedMotion = window.matchMedia(`(prefers-reduced-motion: reduce)`) === true || window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true;

jQuery(() => {
    // global functionality goes here
    const $html = $('html'),
        $body = $('body'),
        $masthead = $('header.masthead');

    $html.addClass('jsenabled');

    if(isiOs()) $html.addClass('browser-ios');
    if(isIE()) $html.addClass('browser-ie');
    if(isChrome()) $html.addClass('browser-chrome');
    if(isFirefox()) $html.addClass('browser-firefox');
    if(isSafari()) $html.addClass('browser-safari');

    // prevent disabled buttons to execute default actions
    $('.btn--disabled').on('click', function(e) {
        e.preventDefault();
    });

    // disable hero-video with URL variable
    if (window.location.search.indexOf('no_video=1') >= 0) {
        $('.section__background-video').hide();
    }

    // load extra JS parts
    require('./modules/dev-env');
    require('./modules/lenis');
    require('./modules/content-animations');
    require('./modules/pagination');
    require('./modules/btns');
    require('./modules/masthead');
    require('./modules/key-visual');
    require('./modules/footer-reveal');
    require('./modules/footer-icon');
    require('./modules/insert-icons');
    require('./modules/html-videos');
    require('./modules/sliders');
    require('./modules/tooltips');
    require('./modules/scroll-to-top');
    //require('./modules/smooth-scroll-to'); // let Lenis handle this
    require('./modules/gravity-forms');
    require('./modules/gtm-events');
    require('./modules/anchors-missing-title');
    require('./modules/menu-overlay');
    require('./modules/expandable-items');
    require('./modules/page-transition');
    require('./modules/page-loader');
});
